<template>
  <div class="rating">
    <input class="rating__input" type="radio" checked disabled :name="`rating-${_uid}`">
    <template v-for="(item, itemIndex) in items">
      <label
        class="rating__item"
        :for="`rating-${_uid}-${item[itemValue]}`"
        :key="`label-${item[itemValue]}`"
        :title="item[itemText]"
        :aria-label="item[itemText]"
      >
        <Icon v-if="isTypeStar" name="star" size="lg" class="rating__icon"/>
        <span
        v-else type="button"
        class="rating__button"
        :class="{'active-rate': ratingButton === item.value}"
        :style="{
          'background-color': bgColor,
          'color': textColor,
          'border-color': textColor
          }"
        >
        {{item[itemText]}}
        </span>
      </label>
      <input
        :key="`value-${item[itemValue]}`"
        class="rating__input"
        type="radio"
        :name="`rating-${_uid}`"
        v-model="internalValue"
        v-on:click="sendValue(item)"
        :value="item[itemValue]"
        :id="`rating-${_uid}-${item[itemValue]}`"
      >
      <theme-style :key="`item-${itemIndex}`">
        .rating__button  {
          background-color:  {{ bgColor || '#2d3991' }} !important;
        }
        .rating__button:hover, .active-rate  {
          background-color:  {{ hoverColor || '#2d3991' }} !important;
        }
      </theme-style>
    </template>
  </div>
</template>

<script>
import Icon from '../Icon/Icon.vue'
import ThemeStyle from '../Theme/ThemeStyle.vue'

export default {
  name: 'AppFormRate',
  status: 'prototype',
  release: '1.0.0',
  inheritAttrs: false,
  components: { Icon, ThemeStyle },
  props: {
    value: {
      required: true
    },
    bgColor: {
      type: String,
      default: 'value'
    },
    hoverColor: {
      type: String
    },
    textColor: {
      type: String,
      default: 'value'
    },
    labelColor: {
      type: String,
      default: 'value'
    },
    items: {
      type: Array,
      default: () => []
    },
    itemValue: {
      type: String,
      default: 'value'
    },
    itemText: {
      type: String,
      default: 'text'
    },
    type: {
      type: String,
      default: 'button'
    }
  },
  data () {
    return {
      lazyValue: this.value,
      ratingButton: ''
    }
  },
  methods: {
    sendValue (item) {
      this.ratingButton = item.value
      this.$emit('rate-value', item.value)
    }
  },
  computed: {
    internalValue: {
      get () {
        return this.lazyValue
      },
      set (val) {
        this.lazyValue = val
        this.$emit('input', val)
      }
    },
    isTypeStar () {
      return this.type === 'star'
    }
  },
  watch: {
    value (val) {
      this.lazyValue = val
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/styles.scss";
$text-shadow-default: 0 5px 15px rgb(239, 243, 248);
.rating {
  @include clear-both();
  position: relative;
  display: inline-block;
  padding-bottom: 30px;

  &__item {
    display: inline-block;
    float: left;
    cursor: pointer;
  }
  &__icon {
    display: block;
    width: 54px;
    height: 52px;
    color: $color-purple-light;
    &:before {
      width: 100%;
      display: block;
      text-indent: -9px;
      line-height: 50px;
    }
  }
  &__button {
    display: inline-block;
    width: 45px;
    height: 45px;
    margin-right: 9px;
    border: 0;
    border-radius: 50%;
    font-family: $font-text;
    background: $color-purple-light;
    font-size: $size-s;
    font-weight: 600;
    text-align: center;
    line-height: 45px;
    color: $color-white;
    cursor: pointer;
    outline: none;
    user-select: none;
  }
  &__input {
    display: none;
  }
  &__label {
    position: absolute;
    bottom: 0;
    font-family: $font-text;
    font-size: $size-s;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.22;
    letter-spacing: normal;
    color: $color-purple-darker;
    &--min {
      left: 0;
    }
    &--max {
      right: 6px;
    }
  }
}
.active-rate {
   opacity: 1.0;
   border:2px solid;
   transition: all .2s ease-in-out;
   transform: scale(1.1);
}
</style>
